import CrudReducer from './crudReducer';

const cr = new CrudReducer('advisor_license');

const reducer = cr.Reducer;

export default reducer;
